module.exports = __webpack_public_path__ + "img/house.3dc5cfc3.svg";